/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const BrittleIcon: React.SFC = () => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
            <title>Icon / brittle</title>
            <g fill="none" fillRule="evenodd">
                <path fill="#F07662" d="M16 40h15v-1H16M23 39h1V24h-1" />
                <g stroke="#F07662">
                    <path d="M28 6.5h4.5V16c0 4.694-4.03 8.5-9 8.5s-9-3.806-9-8.5V6.5H24" />
                    <path d="M24.5 6.5l-3 5 2 2v4l3-4-1-2 3-5" />
                </g>
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/AssetsIcons/Brittle.tsx